import { render, staticRenderFns } from "./requirementDetail.vue?vue&type=template&id=3a8f1680&"
import script from "./requirementDetail.vue?vue&type=script&lang=ts&"
export * from "./requirementDetail.vue?vue&type=script&lang=ts&"
import style0 from "./requirementDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports